import React, { createContext, useContext, useState, useEffect } from 'react';
import { getTranslation, DEFAULT_LANGUAGE } from '../utils/translations';
import { LANGUAGES } from '../utils/languages';

const TranslationContext = createContext();

export function TranslationProvider({ children }) {
  const [language, setLanguage] = useState(DEFAULT_LANGUAGE);
  const [showLanguageModal, setShowLanguageModal] = useState(false);

  // Load language from localStorage on mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('app_language');
    if (savedLanguage && LANGUAGES.find(lang => lang.code === savedLanguage)) {
      setLanguage(savedLanguage);
    } else {
      // Show modal if no language is saved
      setShowLanguageModal(true);
    }
  }, []);

  // Save language to localStorage when it changes
  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('app_language', newLanguage);
    setShowLanguageModal(false);
  };

  const t = (key, params) => {
    return getTranslation(language, key, params);
  };

  return (
    <TranslationContext.Provider value={{ language, changeLanguage, t, showLanguageModal, setShowLanguageModal }}>
      {children}
    </TranslationContext.Provider>
  );
}

export function useTranslation() {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
}

